var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.7,42c-46.1,0-92.2,14.7-129.9,44.1s-64.9,69.3-77.5,115.5S40.9,296,57.7,338c18.9,44.1,52.4,79.8,92.2,102.9c39.8,23.1,88,33.6,134,27.3c46.1-6.3,90.1-27.3,123.6-60.9s54.5-77.7,60.7-123.9S464,189,441,149.1c-6.3-12.6-23-16.8-33.5-8.4c-12.6,6.3-16.8,23.1-8.4,33.6c18.9,31.5,25.1,67.2,20.9,102.9c-4.2,35.7-20.9,69.3-46.1,94.5c-25.1,25.2-58.6,42-94.3,46.2s-71.2-2.1-102.6-21c-31.4-18.9-54.5-46.2-69.1-79.8s-16.8-69.3-6.3-105c8.4-35.7,29.3-65.1,58.6-88.2c29.3-21,62.8-33.6,98.4-33.6c14.7,0,25.1-10.5,25.1-25.2S271.3,42,256.7,42z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 256 256",
    to: "360 256 256",
    dur: "1.0s",
    additive: "sum",
    repeatCount: "indefinite",
    values: "0 256 256 ; 90 256 256 ; 180 256 256 ; 270 256 256 ; 360 256 256",
    keyTimes: "0; 0.15; 0.3; 0.6; 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.fed1f9f1987f16c1bce260f6a9272c81.svg";
export { ForwardRef as ReactComponent };